/**
 * Workflows, ang mga karagdagang template: booking card o lead form na nagsasara pagkatapos ng ilang sandali ("Hindi na-book
 * sa loob ng 30 min") at paghihintay hanggang magbukas ang opisina. Isinasama sa `engage.workflows` (summaries, exits at fields).
 */
export const workflowsFollowups = {
  summaries: {
    waitUntilOpen: "Maghintay hanggang magbukas ang opisina",
  },
  exits: {
    notSubmitted: "Hindi naipadala ang detalye",
    notBooked_minutes_one: "Hindi na-book sa loob ng {{count}} min",
    notBooked_minutes_other: "Hindi na-book sa loob ng {{count}} min",
    notBooked_hours_one: "Hindi na-book sa loob ng {{count}} oras",
    notBooked_hours_other: "Hindi na-book sa loob ng {{count}} oras",
    notBooked_days_one: "Hindi na-book sa loob ng {{count}} araw",
    notBooked_days_other: "Hindi na-book sa loob ng {{count}} araw",
    notSubmitted_minutes_one: "Hindi naipadala ang detalye sa loob ng {{count}} min",
    notSubmitted_minutes_other: "Hindi naipadala ang detalye sa loob ng {{count}} min",
    notSubmitted_hours_one: "Hindi naipadala ang detalye sa loob ng {{count}} oras",
    notSubmitted_hours_other: "Hindi naipadala ang detalye sa loob ng {{count}} oras",
    notSubmitted_days_one: "Hindi naipadala ang detalye sa loob ng {{count}} araw",
    notSubmitted_days_other: "Hindi naipadala ang detalye sa loob ng {{count}} araw",
  },
  fields: {
    waitMode: "Paghihintay",
    waitModes: { for: "Para sa itinakdang oras", office: "Hanggang magbukas ang opisina" },
    waitOfficeHint: "Hihintayin ang susunod na pagbubukas ng opisina ng agent (ang office hours nito, sa time zone ng inyong workspace) at lalaktawan kapag bukas na ang opisina. Hanggang {{value}} {{unit}} lang ang paghihintay sa inyong plan: kung mas matagal ang pagsasara, magtatapos ang paghihintay sa limitasyong iyon.",
    bookingTimeout: "Isara ang booking card pagkatapos ng",
    bookingTimeoutHint: "Kapag walang booking sa oras na iyon, isasara ang card para sa bisita at susundan ng run ang exit na Hindi na-book.",
    leadTimeout: "Isara ang form pagkatapos ng",
    leadTimeoutHint: "Kapag hindi naipadala ang detalye sa oras na iyon, isasara ang form para sa bisita at susundan ng run ang exit na Hindi naipadala ang detalye.",
  },
} as const;
